<template>
  <div v-if="$ability.can('read', this.$route.meta.resource)">
    <sidebar
      :store-module-name="STORE_MODULE_NAME"
      :is-sidebar-active.sync="isSidebarActive"
      :show.sync="show"
      :data="sidebarData"
    />
    <modal
      :store-module-name="STORE_MODULE_NAME"
      :is-modal-active.sync="isModalActive"
      :show.sync="show"
      :data="modalData"
    />
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-1"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <span style="font-size: 20px;">{{ $t('Filter') }}</span>
            </b-col>
            <b-col
              cols="2"
              md="2"
              class="b-col-custom"
            >
              <b-form-group>
                <b-form-checkbox
                  id="expire"
                  v-model="expire_status"
                  name="checkbox-1"
                  @input="searchWithStatus()"
                >
                  {{ $t('Expire') }}
                </b-form-checkbox>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                  id="close-expire"
                  v-model="close_expire"
                  name="checkbox-2"
                  @input="searchWithStatus()"
                >
                  {{ $t('Close to expiration') }}
                </b-form-checkbox>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                  id="active-status"
                  v-model="active_status"
                  name="checkbox-3"
                  @input="searchWithStatus()"
                >
                  {{ $t('Active') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col
              cols="2"
              md="2"
              class="b-col-custom"
            >
              <span style="font-size: 14px;">{{ $t('Partner') }}</span>
              <v-select
                v-model="selectedPartner"
                :options="respDataPartners"
                :reduce="respDataPartners => respDataPartners.partnerUserId._id"
                @input="selectPartner($event)"
              >
                <template
                  slot="option"
                  slot-scope="option"
                >
                  {{ option.partnerUserId.tel }} : {{ option.firstName }}
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option"
                >
                  {{ option.partnerUserId.tel }} :{{ option.firstName }}
                </template>
              </v-select>
            </b-col>
            <b-col
              cols="6"
              md="6"
              class="b-col-custom"
            >
              <span style="font-size: 14px;">{{ $t('Search') }}</span>
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('Search') + '...'"
                  @input="typing($event)"
                />
                <!-- <b-form-file
                  @change="importFileJson"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  accept=".json"
                /> -->
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <label>{{ $t('Show') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector v-select-custom"
                @input="pageSize"
              />
              <label for="">{{ $t('entries') }}</label>
              <span
                class="ml-1 text-muted"
              >{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t('of') }} {{ queriedItems }}</span>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          striped
          responsive
          class="position-relative"
          :items="respData"
          :fields="tableColumns"
          primary-key="_id"
          show-empty
          :empty-text="$t('No matching records found')"
          style="height: 45vh;"
        >
          <!-- Column: Images -->
          <template #cell(image)="data">
            <b-row>
              <b-img
                v-if="data.item.image"
                :src="data.item.image"
                fluid
                thumbnail
                width="100px"
                :alt="'Users_' + data.item._id"
              />
              <b-img
                v-else
                :src="require('@/assets/images/blank/no_image.png')"
                fluid
                thumbnail
                width="100px"
                :alt="'Users_' + data.item._id"
              />
            </b-row>
          </template>
          <template #cell(name)="data">
            <p class="align-text-bottom line-height-1">
              {{ data.item.firstName + ' ' + data.item.lastName }}
            </p>
          </template>
          <template #cell(show)="data">
            <b-row class="d-flex align-items-left justify-content-left mt-1">
              <feather-icon
                icon="CircleIcon"
                size="16"
                :color="data.item.status_hide == 'block' ? 'red' : 'green'"
              />
              <v-select
                v-model="data.item.status_hide"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="optionsStatus"
                :reduce="optionsStatus => optionsStatus.value"
                :clearable="false"
                class="per-page-selector v-select-custom"
                @input="changeStatus(data.item)"
              />
            </b-row>
          </template>
          <template #cell(verified)="data">
            <b-form-checkbox
              v-model="data.item.verified"
              switch
              @input="verifiedStatus(data.item)"
            />
          </template>
          <template #cell(open_status)="data">
            <b-form-checkbox
              v-model="data.item.openingStatus"
              switch
              @input="openStatus(data.item)"
            />
          </template>
          <template #cell(package)="data">
            <!-- <b-badge
              :variant="data.item.servicePackageId ? 'success' : 'danger'"
              style="width:250px;"
            >
              {{ data.item.servicePackageId ? data.item.servicePackageId.name : $t("Haven't bought a package yet.") }}
            </b-badge> -->
            <!-- <b-button :style="`color:${data.item.servicePackageId == null ? 'red' : data.item.servicePackageId.color}`"> -->
            <p
              v-if="data.item.servicePackageId == null"
              class="align-text-bottom line-height-1"
            >
              {{ $t('No package') }}
            </p>
            <p
              v-if="data.item.servicePackageId"
              class="align-text-bottom line-height-1"
            >
              {{ data.item.servicePackageId.name }}
            </p>
            <!-- </b-button> -->
          </template>

          <template #cell(partner_name)="data">
            <!-- <b-row>
              <p
                v-if="!data.item.userInfoId"
                class="align-text-bottom line-height-1"
              >{{ $t("No partner") }}</p>
            </b-row> -->
            <b-row>
              <b-button
                variant="primary"
                class="mr-2"
                @click="loginProfile(data.item)"
              >
                {{ $t('Login') }}
              </b-button>
            </b-row>
          </template>

          <template #cell(expire)="data">
            <div v-if="data.item.servicePackageId">
              <span
                v-if="
                  daysBetween(
                    new Date().toISOString(),
                    data.item.expirePackage,
                  ) > 0
                "
                class="align-middle ml-50"
              >{{ $t('Time left') }}
                {{
                  expireText(
                    daysBetween(
                      new Date().toISOString(),
                      data.item.expirePackage,
                    ),
                  )
                }}
                {{ $t('Day') }}</span>
              <span
                v-else
                class="align-middle ml-50"
                style="color:red;"
              >{{
                $t('Out of time')
              }}</span>
            </div>
            <div v-else>
              <span
                class="align-middle ml-50"
                style="color:red;"
              >-</span>
            </div>
            <!-- <span class="align-middle ml-50">{{ data.item.startDate + " "+data.item.expireDate }}</span> -->
          </template>
          <!-- Column: Action -->
          <template #cell(action)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="modalPackage(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{
                  $t('Manage Package')
                }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="viewPackagePurchase(data.item)">
                <feather-icon icon="EyeIcon" />
                <span class="align-middle ml-50">{{
                  $t('View Package Purchase')
                }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteData(data.item._id)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t('Delete') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span
                class="text-muted"
              >{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t('of') }} {{ queriedItems }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="queriedItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="nextPage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  // BBadge,
  BAvatar,
  BFormInput,
  // BButton,
  BTable,
  BPagination,
  BDropdown,
  BOverlay,
  BFormCheckbox,
  BFormGroup,
  BDropdownItem,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import perPageOptions from '@/perPageOptions'
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/store/services/hero/manageProfile'
import debounce from 'debounce'
import Sidebar from './DataSidebar.vue'
import Modal from './Modal.vue'

const STORE_MODULE_NAME = 'serviceType'

export default {
  components: {
    BCard,
    // BBadge,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    // eslint-disable-next-line vue/no-unused-components
    BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BFormGroup,
    // BFormCheckbox,
    BOverlay,
    // BButton,
    // BFormFile,
    // BBadge,
    // BLink,
    // BMedia,
    // BAvatar,
    Sidebar,
    Modal,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      avatarText,
      currentPage: 1,
      searchQuery: '',
      perPage: localStorage.getItem('itemsPerPage')
        ? localStorage.getItem('itemsPerPage')
        : 50,
      isSidebarActive: false,
      isModalActive: false,
      sidebarData: {},
      modalData: {},
      show: false,
      selectedPartner: null,
      expire_status: false,
      close_expire: false,
      active_status: false,
      perPageOptions,
    }
  },
  computed: {
    optionsStatus() {
      return [
        { name: this.$t('Block'), value: 'block' },
        { name: this.$t('Active'), value: 'show' },
      ]
    },
    tableColumns() {
      return [
        { key: 'image', label: this.$t('Image'), sortable: false },
        { key: 'name', label: this.$t('Name'), sortable: false },
        { key: 'show', label: this.$t('Status'), sortable: false },
        { key: 'verified', label: this.$t('Verify'), sortable: false },
        { key: 'open_status', label: this.$t('Open Shop'), sortable: false },
        { key: 'package', label: this.$t('Package'), sortable: false },
        {
          key: 'partner_name',
          label: this.$t('Partner Name'),
          sortable: false,
        },
        { key: 'expire', label: this.$t('Expire'), sortable: false },
        { key: 'action', label: this.$t('ACTION'), sortable: false },
      ]
    },
    respData() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.data
        : []
    },
    respDataPartners() {
      return store.state[STORE_MODULE_NAME].respDataPartners != null
        ? store.state[STORE_MODULE_NAME].respDataPartners.data
        : []
    },
    queriedItems() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.max
        : 0
    },
    // eslint-disable-next-line vue/return-in-computed-property
  },
  created() {
    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)
    const type = this.$route.path.split('/')
    this.type = type[type.length - 1]
    const obj = {
      currentPage: this.currentPage,
      pageSize: this.perPage,
      searchQuery: this.searchQuery,
      partnerUserId: this.selectedPartner,
      expire: this.expire_status,
      active_status: this.active_status,
      close_expire: this.close_expire,
    }

    this.show = true
    store
      .dispatch(`${STORE_MODULE_NAME}/get`, obj)
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        this.show = false
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        // eslint-disable-next-line no-unused-vars
      })
      .catch(error => {
        this.show = false
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: this.$t('Error'),
            icon: 'ErrorIcon',
            variant: 'danger',
            text: this.$t(error.response.data.message),
          },
        })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
      })
    this.show = true
    store
      .dispatch(`${STORE_MODULE_NAME}/getPartners`, obj)
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        this.show = false
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        // eslint-disable-next-line no-unused-vars
      })
      .catch(error => {
        this.show = false
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: this.$t('Error'),
            icon: 'ErrorIcon',
            variant: 'danger',
            text: this.$t(error.response.data.message),
          },
        })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
      })
    this.typing = debounce(this.typing, 500)
  },
  destroyed() {
    if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
  },
  setup() {
    return { STORE_MODULE_NAME }
  },
  methods: {
    loginProfile(data) {
      const { partnerUserId, partnerUserInfoId } = data.staff[0]
      const profileId = data._id
      console.log(partnerUserId, partnerUserInfoId, profileId)
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/loginProfile`, {
          partnerUserId,
          partnerUserInfoId,
          profileId,
        })
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          const urlLogin = process.env.NODE_ENV === 'production'
            ? 'https://partner-hero.startapp.me/'
            : 'http://localhost:34209/'
          window.open(
            `${urlLogin}select-user?token=${result.data.data.token}&id=${result.data.data._id}&profile=${profileId}`,
            '_blank',
          )
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    searchWithStatus() {
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        partnerUserId: this.selectedPartner,
        expire: this.expire_status,
        active_status: this.active_status,
        close_expire: this.close_expire,
      }

      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
          // console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        })
        .catch(error => {
          this.show = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    selectPartner() {
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        partnerUserId: this.selectedPartner,
        expire: this.expire_status,
        active_status: this.active_status,
        close_expire: this.close_expire,
      }

      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
          // console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        })
        .catch(error => {
          this.show = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    viewPackagePurchase(item) {
      console.log(item)
      const urlLogin = process.env.NODE_ENV === 'production'
        ? 'https://manager.startapp.me/'
        : 'http://localhost:34208/'
      window.open(
        `${urlLogin}hero/package/purchase?partnerUserId=${item.partnerUserId}&partnerProfileId=${item._id}`,
        '_blank',
      )
    },
    modalPackage(value) {
      console.log(value)
      this.modalData = value
      this.isModalActive = true
    },
    expireText(value) {
      if (value < 1) {
        return this.$t('less than 1')
      }
      return Math.ceil(value)
    },
    treatAsUTC(date) {
      const result = new Date(date)
      result.setMinutes(result.getMinutes() - result.getTimezoneOffset())
      return result
    },
    daysBetween(startDate, endDate) {
      const millisecondsPerDay = 24 * 60 * 60 * 1000
      return (
        (this.treatAsUTC(endDate) - this.treatAsUTC(startDate))
        / millisecondsPerDay
      )
    },
    verifiedStatus(value) {
      const obj = {
        _id: value._id,
        value: value.verified,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/verifiedUpdate`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    openStatus(value) {
      const obj = {
        _id: value._id,
        value: value.openingStatus,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/updateOpen`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    changeStatus(value) {
      const obj = {
        _id: value._id,
        value: value.status_hide,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/updateStatus`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    showFromCurrentLanguage(data) {
      const indexLang = data.findIndex(e => e.lang === this.$i18n.locale)
      if (indexLang > -1) {
        return data[indexLang].value
      }
      return ''
    },
    typing(value) {
      console.log(value)
      this.searchQuery = value
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        partnerUserId: this.selectedPartner,
        expire: this.expire_status,
        active_status: this.active_status,
        close_expire: this.close_expire,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    sidebarAddNew() {
      this.sidebarData = {}
      this.isSidebarActive = true
    },
    sidebarEdit(item) {
      this.sidebarData = item
      this.isSidebarActive = true
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm(`${this.$t('Do you want to delete')}?`, {
          title: this.$t('Please Confirm'),
          cancelVariant: 'outline-secondary',
          okVariant: 'danger',
          okTitle: this.$t('Yes'),
          cancelTitle: this.$t('No'),
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.show = true
            store
              .dispatch(`${STORE_MODULE_NAME}/delete`, id)
              .then(result => {
                this.show = false
                console.log('fetch Success : ', result)
              })
              .catch(error => {
                this.show = false
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
              })
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    pageSize(size) {
      localStorage.setItem('itemsPerPage', size)
      this.perPage = size
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        partnerUserId: this.selectedPartner,
        expire: this.expire_status,
        active_status: this.active_status,
        close_expire: this.close_expire,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    nextPage(page) {
      this.currentPage = page
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        partnerUserId: this.selectedPartner,
        expire: this.expire_status,
        active_status: this.active_status,
        close_expire: this.close_expire,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    showToast(variant, position, text, icon, title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            text,
            // icon: 'InfoIcon',
            // text: 'I do not think that word means what you think it means.',
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.v-select-custom {
  display: inline-block;
  width: 50;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.b-col-custom {
  margin-top: 0.5rem;
}
</style>
